import { render, staticRenderFns } from "./ed-deck-card-side.component.vue?vue&type=template&id=cc441b14&scoped=true&"
import script from "./ed-deck-card-side.component.ts?vue&type=script&lang=ts&"
export * from "./ed-deck-card-side.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-deck-card-side.component.scss?vue&type=style&index=0&id=cc441b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc441b14",
  null
  
)

export default component.exports